import { Component, Input } from '@angular/core';

import { Usage } from '@shared/restaurant/models';
import { PaymentPlanCodes } from '@shared/price-plan/enums';
import { PricePlan } from '@shared/price-plan/models';
import { SubscriptionTypes } from '@shared/restaurant/enums';

const PRICE_INT_TO_FLOAT = 100;

@Component({
  selector: 'tablesready-sms-usage',
  templateUrl: './sms-usage.component.html',
  styleUrls: ['./sms-usage.component.scss'],
})
export class SmsUsageComponent {
  @Input() subscriptionType: SubscriptionTypes;
  @Input() pricePlan?: PricePlan;
  @Input() usage?: Usage;
  @Input() showPrice = true;
  @Input() timezone = '';

  subscriptionTypes = SubscriptionTypes;
  paymentPlanCodes = PaymentPlanCodes;

  getPrice(): number {
    if (!this.pricePlan) {
      return 0;
    }

    return this.pricePlan.price / PRICE_INT_TO_FLOAT;
  }
}
